import { useEffect, useRef, useState } from "react";
import { ChevronDown, User, Settings, LogOut } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { CDN } from "../../redux/helpers/urlConfig";
import { adminLogout } from "../../redux/actions";
import { ProfileModal } from "../modal/profile";

export default function SidebarUserMenu() {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const menuRef = useRef(null);

  const onCloseModal = () => {
    setModalOpen(false);
  };

  const handleLogout = () => {
    setOpen(false);
    dispatch(adminLogout());
  };

  // close on outside click
  useEffect(() => {
    function onDocClick(e) {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="mt-6 relative" ref={menuRef}>
      {/* user card */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full rounded-2xl bg-white p-3 ring-1 ring-slate-200 hover:bg-slate-50 transition"
      >
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full">
            <img
              src={
                `${CDN}${auth?.admin?.avatar?.path}` || "/default-avatar.png"
              }
              alt="Admin Avatar"
              className="rounded-full h-full w-full"
            />
          </div>
          <div className="min-w-0 text-left">
            <div className="text-sm font-semibold text-slate-900 truncate">
              {auth?.admin?.name || "Admin Name"}
            </div>
            <div className="text-xs text-slate-500 truncate">
              {auth?.admin?.email || "admin@alistore.com.bd"}
            </div>
          </div>
          <ChevronDown
            className={`ml-auto h-4 w-4 text-slate-400 transition ${
              open ? "rotate-180" : ""
            }`}
          />
        </div>
      </button>

      {/* dropdown */}
      {open && (
        <div className="absolute left-0 right-0 bottom-[calc(100%+10px)] z-50">
          <div className="rounded-2xl bg-white p-2 ring-1 ring-slate-200 shadow-lg">
            <button
              className="w-full flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
              onClick={() => {
                setOpen(false);
                // navigate("/admin/profile") // if you have a profile page
                setModalOpen(true);
              }}
            >
              <User className="h-4 w-4" />
              Profile
            </button>

            <button
              className="w-full flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
              onClick={() => {
                setOpen(false);
                // navigate("/admin/settings")
                alert("Settings clicked");
              }}
            >
              <Settings className="h-4 w-4" />
              Settings
            </button>

            <div className="my-1 h-px bg-slate-100" />

            <button
              className="w-full flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-rose-600 hover:bg-rose-50"
              onClick={() => {
                handleLogout();
              }}
            >
              <LogOut className="h-4 w-4" />
              Logout
            </button>
          </div>
        </div>
      )}

      {/* Profile Modal */}
      {modalOpen && <ProfileModal open={modalOpen} onClose={onCloseModal} />}
    </div>
  );
}
